<template functional>
        <span class="nobr" v-if="props.val" :class="props.val < 0 ? ('red px-1' + props.class) : ('black px-1' + props.class) " :style="{color: props.color + '!important', backgroundColor: props.bgColor}">
            {{props.prefix}}{{ parseFloat(props.val).toFixed(props.round) }}{{props.suffix}}
        </span>
        <span v-else-if="props.val == 0" class="black px-1" :style="{color: props.color, backgroundColor: props.bgColor}">{{props.prefix}}0{{props.suffix}}</span>
        <span v-else class="not-available">n/a</span>
</template>

<script>
export default {
    props:
        {
            'val': {},
            'round': {
                type: Number,
                default: 2
            },
            'prefix': {
                type: String,
                default: ""
            },
            'suffix': {
                type: String,
                default: ""
            },
            class: {
                type: String,
                default: ""
            },
            color: {
                type: String,
                default: ""
            },
            bgColor: {
                type: String,
                default: ""
            }
        }
}
</script>

<style scoped>
    .nobr{
        white-space: nowrap;
    }
</style>
